import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const UnreadLabel = styled.div`
  flex: 0 0 15px;
  width: 15px;
  height: 15px;
  margin-left: 5px;
  border-radius: 50%;
  background-color: ${COLORS.success};
`;

export default UnreadLabel;
